// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2rsr6","footer":"ReportModalFilter_footer__8KZLr"};